import * as React from 'react';
import { cn } from '../../lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    /** Element to render inside the input on the right (e.g. button) */
    suffix?: React.ReactNode;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, suffix, ...props }, ref) => {
        const inputClassName = cn(
            'flex h-9 w-full min-w-0 rounded-md border border-border bg-surface px-3 py-1 text-base text-foreground shadow-sm transition-[color,box-shadow] outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:bg-surface/80 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40',
            suffix && 'pr-12',
            className
        );

        if (suffix) {
            return (
                <div className="input-with-suffix relative flex h-9 w-full items-center">
                    <input
                        type={type}
                        data-slot="input"
                        className={inputClassName}
                        ref={ref}
                        {...props}
                    />
                    <div className="input-suffix absolute right-2 top-1/2 -translate-y-1/2">
                        {suffix}
                    </div>
                </div>
            );
        }

        return (
            <input type={type} data-slot="input" className={inputClassName} ref={ref} {...props} />
        );
    }
);
Input.displayName = 'Input';

export { Input };
